"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "silandro": {
    "3209258d": [{
      "hkey": "91f33fb1",
      "slug": "silandro",
      "name": "Silandro",
      "primary": true,
      "skipSearch": false
    }],
    "corces": [{
      "hkey": "91f33fb1",
      "slug": "silandro",
      "name": "Silandro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "41af80c5": [{
      "hkey": "91f33fb1",
      "slug": "silandro",
      "name": "Silandro",
      "primary": true,
      "skipSearch": false
    }],
    "monte-mezzodi": [{
      "hkey": "91f33fb1",
      "slug": "silandro",
      "name": "Silandro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bddaee80": [{
      "hkey": "91f33fb1",
      "slug": "silandro",
      "name": "Silandro",
      "primary": true,
      "skipSearch": false
    }],
    "monte-tramontana": [{
      "hkey": "91f33fb1",
      "slug": "silandro",
      "name": "Silandro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;